import type { ColumnConfig } from '../../../hooks/useColumnConfig';

export const ATTENDANCE_COLUMNS: ColumnConfig[] = [
  // Participant identity
  { id: 'participant_email', label: 'Participant Email', visible: true, sortable: true, groupable: false, exportKey: 'email' },
  { id: 'participant_full_name', label: 'Participant Full Name', visible: true, sortable: true, exportKey: 'full_name' },

  // Primary metrics (MED-751: engagement first after identifiers)
  { id: 'engagement_rating', label: 'Engagement', visible: true, sortable: false, groupable: false, exportKey: 'engagement_rating', numeric: 'decimal' },

  // Session info
  { id: 'session_number', label: 'Session Number', visible: true, sortable: true },
  { id: 'session_topic', label: 'Session Topic', visible: true, sortable: false, exportKey: 'session_topic' },
  { id: 'session_date', label: 'Session Date', visible: true, sortable: true },

  // Cohort context
  { id: 'cohort_name', label: 'Cohort', visible: true, sortable: false },
  { id: 'cohort_health', label: 'Cohort Health', visible: false, sortable: false, groupable: false, exportKey: 'cohort_health' },

  // Group & Coach
  { id: 'coach_name', label: 'Coach', visible: true, sortable: true },
  { id: 'group_name', label: 'Group', visible: true, sortable: true },

  // Status & Attendance
  { id: 'participant_status', label: 'Status', visible: true, sortable: false, exportKey: 'status' },
  { id: 'attendance_status', label: 'Attendance', visible: true, sortable: true },

  // Notes
  { id: 'coach_notes', label: 'Coach Notes', visible: false, sortable: false, groupable: false },

  // Aggregates
  { id: 'overall_attendance_rate', label: 'Overall Attendance Rate', visible: true, sortable: true, groupable: false, numeric: 'percent' },
  // MDF-212: the participant's average engagement, as on the Participants tab.
  { id: 'avg_engagement', label: 'Avg Engagement', visible: true, sortable: true, groupable: false, exportKey: 'avg_engagement', numeric: 'decimal' },
  { id: 'session_attendance_rate', label: 'Session Attendance Rate', visible: false, sortable: true, groupable: false, numeric: 'percent' },
  // MED-1266 (AC12): marking coverage shown as its own column alongside each rate.
  { id: 'overall_attendance_coverage', label: 'Overall Attendance Coverage', visible: false, sortable: false, groupable: false, exportKey: 'overall_attendance_coverage' },
  { id: 'session_attendance_coverage', label: 'Session Attendance Coverage', visible: false, sortable: false, groupable: false, exportKey: 'session_attendance_coverage' },

  // Demographics
  { id: 'business_unit', label: 'Business Unit', visible: false, sortable: false },
  { id: 'department', label: 'Department', visible: false, sortable: false },
  { id: 'role', label: 'Role', visible: false, sortable: false },

  // Cohort status
  { id: 'cohort_status', label: 'Cohort Status', visible: false, sortable: false },

  // Location & Repeat
  { id: 'location', label: 'Location', visible: false, sortable: false },
  { id: 'repeat_medley', label: 'Repeat Medley', visible: false, sortable: false },

  // Flags
  { id: 'flags', label: 'Flags', visible: true, sortable: false, groupable: false },

  // Absence counts
  { id: 'total_unexcused', label: 'Total # Unexcused Absences', visible: false, sortable: true, groupable: false, numeric: 'decimal' },
  { id: 'total_missed', label: 'Total # Missed', visible: false, sortable: true, groupable: false, numeric: 'decimal' },
];

export const DEFAULT_VISIBLE_ATTENDANCE_COLUMNS = ATTENDANCE_COLUMNS.filter(c => c.visible).map(
  c => c.id,
);
